import React, { useState } from "react";
import { useHistory, useLocation } from "react-router";
import useAuth from "./../../../hooks/useAuth";
import "./Login.css";

const Login = () => {
    const { signInUsingGoogle, setUser, setIsLoading } = useAuth();
    const [error, setError] = useState("");
    const location = useLocation();
    const history = useHistory();
    const redirect_url = location.state?.from || "/";
    const loginWithGoogle = () => {
        signInUsingGoogle()
            .then((result) => {
                setUser(result.user);
                history.push(redirect_url);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };
    return (
        <div className="container mt-5">
            <div className="row">
                <div className="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div className="card border-0 shadow rounded-3 my-5">
                        <div className="card-body p-4 p-sm-5">
                            <h5 className="card-title text-center mb-5 fw-light fs-5">
                                Sign In
                            </h5>
                            <form>
                                <div className="form-floating mb-3">
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="floatingInput"
                                        placeholder="name@example.com"
                                    />
                                    <label htmlFor="floatingInput">
                                        Email address
                                    </label>
                                </div>
                                <div className="form-floating mb-3">
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="floatingPassword"
                                        placeholder="Password"
                                    />
                                    <label htmlFor="floatingPassword">
                                        Password
                                    </label>
                                </div>

                                <div className="form-check mb-3">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value=""
                                        id="rememberPasswordCheck"
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="rememberPasswordCheck"
                                    >
                                        Remember password
                                    </label>
                                </div>
                                <div className="d-grid">
                                    <button
                                        className="btn btn-primary btn-login text-uppercase fw-bold"
                                        type="submit"
                                    >
                                        Sign in
                                    </button>
                                </div>
                                <hr className="my-4" />
                                <div className="d-grid mb-2">
                                    <button
                                        className="btn btn-google btn-login text-uppercase fw-bold"
                                        onClick={loginWithGoogle}
                                        type="button"
                                    >
                                        <i className="fab fa-google me-2"></i>{" "}
                                        Sign in with Google
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
